<template>
  <ButtonComponent
    class="list-field-link"
    :icon="['fal', 'external-link']"
    tag="a"
    v-on:click.stop="() => ({})"
    :href="url"
    target="_blank"
  />
</template>

<script>
export default {
  props: {
    item: Object,

    id: {
      type: String,
      defualt: '',
    },
  },

  computed: {
    url() {
      if (!this.item) return
      return this.item[this.id]
    },
  },
}
</script>

<style lang="scss">
.list-field-link.elder-button {
  border: 0;
  &__icon:first-child:last-child {
    padding: 0.5em 0.5em;
  }
}
</style>
